import React, { useEffect, useRef, use } from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';
import AdminCompanyContext from '../../../shared/contexts/AdminCompanyContext';
import EFilingWizard from '../../efiling/components/EFilingWizard';
import OrderAccountBanner from '../../orders/components/OrderAccountBanner';

interface AdminEFilingPageProps {
  brand: BrandConfig;
}

const AdminEFilingPage: React.FC<AdminEFilingPageProps> = ({ brand }) => {
  const adminCompany = use(AdminCompanyContext);
  const selectedCompanyId = adminCompany?.selectedCompanyId ?? null;
  const prevCompanyRef = useRef(selectedCompanyId);

  useEffect(() => {
    if (prevCompanyRef.current && prevCompanyRef.current !== selectedCompanyId) {
      localStorage.removeItem('efilingDraft');
    }
    prevCompanyRef.current = selectedCompanyId;
  }, [selectedCompanyId]);

  if (!selectedCompanyId) {
    return (
      <div className="flex-1 overflow-y-auto p-6" style={{ backgroundColor: brand.colors.bgLight }}>
        <OrderAccountBanner />
        <div className="mt-8 text-center" style={{ color: brand.colors.textLight }}>
          <p className="text-sm">Select a firm above to start an e-filing on their behalf.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      <EFilingWizard key={selectedCompanyId} brand={brand} />
    </div>
  );
};

export default AdminEFilingPage;
